// react
import { Suspense, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

// api
import {
  daluxfmServerApiSlice,
  daluxIntegrationApiSlice,
} from '@/api/apiSlice';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

function AccountLayout() {
  const { accountId } = useParams({
    strict: false,
  });

  const dispatch = useDispatch();
  const previousAccountId = useRef(accountId);

  useEffect(() => {
    if (previousAccountId.current !== accountId) {
      dispatch(daluxfmServerApiSlice.util.resetApiState());
      dispatch(daluxIntegrationApiSlice.util.resetApiState());
      previousAccountId.current = accountId;
    }
  }, [accountId, dispatch]);

  const { t } = useTranslation('states');
  return (
    <Suspense fallback={<div>{t('loading')}</div>}>
      <Outlet />
    </Suspense>
  );
}

export const Route = createFileRoute('/$accountId')({
  component: AccountLayout,
  errorComponent: ErrorBoundary,
});
